/** @flow */
import * as Paths from "./constants";

export const route = <K: $Keys<typeof Paths>>(route: K, params?: Object) => {
  let result = Paths[route] || route;
  for (const prop in params) {
    const regex = new RegExp(`:${prop}\\??`);
    result = result.replace(regex, params[prop]);
  }
  return result;
};
